/**
 * @generated SignedSource<<cc2f8d3182bf8890ae0bb133ece40e0b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type User_user$fragmentType: FragmentType;
export type User_user$data = {|
  +avatar: {|
    +url: string,
  |},
  +email: string,
  +name: string,
  +$fragmentType: User_user$fragmentType,
|};
export type User_user$key = {
  +$data?: User_user$data,
  +$fragmentSpreads: User_user$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "User_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node/*: any*/).hash = "0a857cd68330b2c633b2457e0182a851";

module.exports = ((node/*: any*/)/*: Fragment<
  User_user$fragmentType,
  User_user$data,
>*/);
